import React from "react";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Typography,
  useTheme,
  Zoom,
} from "@mui/material";
import ChooseArgsDialog from "../Dialogs/ChooseArgsDialog";
import { DragIndicator, Edit } from "@mui/icons-material";
import { validActionTaskTypes, validTaskTypes } from "../../constants";

export default function TaskButton({ task, onUpdate, isAuthor }) {
  const [open, setOpen] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const onClose = () => setOpen(false);

  const theme = useTheme();

  const isTaskTypeValid = validTaskTypes.includes(task.type);
  const isActionTaskTypeValid = validActionTaskTypes.includes(task.type);
  const displayArgs =
    typeof task.args === "object" && task.args !== null
      ? JSON.stringify(task.args)
      : task.args || "";

  return (
    <>
      <Button
        size="large"
        variant="text"
        disableTouchRipple={!isTaskTypeValid}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{
          textTransform: "none",
          fontSize: theme.typography.fontSize,
          color: theme.palette.text.primary,
          background: isTaskTypeValid
            ? `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`
            : theme.palette.background.paper,
          width: "100%",
          borderRadius: 2,
          // boxShadow: hover ? 3 : 1,
          cursor: "pointer",
          padding: theme.spacing(1.5),
          margin: theme.spacing(0.5, 0),
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          transition: "all 0.3s ease",
          // border: `1px solid ${hover && isTaskTypeValid
          //   ? theme.palette.primary.main
          //   : theme.palette.divider}`,
          overflow: "hidden",
          ":hover": {
            transform: "translateY(-2px)",
            background: isTaskTypeValid
              ? `linear-gradient(145deg, ${theme.palette.background.default} 0%, ${theme.palette.primary.light}15 100%)`
              : theme.palette.background.default,
          },
        }}
        onClick={() =>
          isTaskTypeValid && isActionTaskTypeValid && isAuthor && setOpen(true)
        }
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 0.5,
            }}
          >
            <Typography
              variant="body1"
              fontWeight={600}
              sx={{ letterSpacing: 0.2 }}
            >
              {task.name}
            </Typography>
            {isTaskTypeValid && displayArgs && (
              <Chip
                label={displayArgs}
                size="small"
                variant="outlined"
                sx={{
                  fontFamily: "monospace",
                  fontSize: "0.7rem",
                  color: theme.palette.primary.main,
                  borderColor: `${theme.palette.primary.light}50`,
                  backgroundColor: `${theme.palette.primary.light}10`,
                  maxWidth: "100%",
                }}
              />
            )}
            {task.errorMessage && (
              <Typography
                variant="body2"
                color="error"
                sx={{
                  backgroundColor: `${theme.palette.error.light}10`,
                  borderRadius: 1,
                  padding: theme.spacing(0.5, 1),
                  fontWeight: 500,
                }}
              >
                {task.errorMessage}
              </Typography>
            )}
          </Box>
        </Box>
        {isTaskTypeValid && isActionTaskTypeValid && isAuthor && (
          // <Zoom in={hover} style={{ transitionDelay: hover ? "100ms" : "60ms" }}>
          <IconButton
            size="small"
            sx={{
              color: theme.palette.primary.main,
              backgroundColor: `${theme.palette.primary.light}15`,
              // '&:hover': {
              //   backgroundColor: `${theme.palette.primary.light}30`,
              // }
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
          // </Zoom>
        )}
      </Button>

      {isTaskTypeValid && isActionTaskTypeValid && isAuthor && (
        <ChooseArgsDialog
          open={open}
          onClose={onClose}
          task={task}
          onUpdate={onUpdate}
        />
      )}
    </>
  );
}
